import styles from './SearchListingLoading.module.css';

export const SearchListingLoading = () => {
	return (
		<div className={styles.listing}>
			<article className={`${styles.card} greyLight rounded`}></article>
			<article className={`${styles.card} greyLight rounded`}></article>
		</div>
	);
};
